// Default HTML content for static pages managed via /admin/static-pages.
// These strings are used to pre-populate the TipTap editor when a page setting
// has never been saved, AND rendered by the public page when no override exists.
// Keeping public + admin defaults in ONE place guarantees WYSIWYG parity.

export const STATIC_DEFAULTS = {
  school: `
    <h2>Eğitimde örnek bir model</h2>
    <p>YEKÜV Nilüfer Gökay Ortaokulu, İstanbul Sarıyer / Ayazağa'da 2003 yılında hizmete girdi. Vakfımızın bağlı olduğu MEB müfredatını destekleyici kültür-sanat ve sosyal programımızla birlikte, öğrencilerimize bütünsel bir eğitim deneyimi sunar.</p>
    <ul>
      <li><strong>Konum:</strong> Ayazağa, Sarıyer / İSTANBUL</li>
      <li><strong>Öğrenci sayısı:</strong> 720+ aktif öğrenci</li>
      <li><strong>Öğretmen kadrosu:</strong> 48 öğretmen</li>
      <li><strong>Hizmet süresi:</strong> 2003'ten beri hizmette</li>
    </ul>
    <h3>Kurucu Adı</h3>
    <p><strong>Prof. Dr. Nilüfer Gökay</strong> — Vakfımızın kurucu başkanı, uzun yıllar sivil eğitimin gelişmesi uğruna çalışmış değerli akademisyenimiz.</p>
  `.trim(),

  units: `
    <h2>Eğitim Destek Birimlerimiz</h2>
    <p>YEKÜV, bursiyerlerinin akademik, sosyal ve kültürel gelişimini destekleyen çeşitli birimlerle hizmet vermektedir. Her birim, kendi uzmanlık alanında öğrencilere rehberlik eder.</p>
    <h3>Kütüphane</h3>
    <p>Vakfımızın Şişli merkezinde bulunan kütüphanemiz; klasikler, ders kitapları, edebiyat, sanat ve bilim yayınlarıyla bursiyerlerimize açıktır.</p>
    <h3>Etüt & Ödev Desteği</h3>
    <p>Öğrencilerimizin haftalık ödev takibi ve etüt çalışmalarına eşlik eden gönüllü öğretmenlerimiz bulunmaktadır.</p>
    <h3>Kültür-Sanat Atölyeleri</h3>
    <p>Resim, müzik, tiyatro ve fotoğraf atölyelerimiz, öğrencilerimizin yaratıcı yönlerini keşfetmelerine imkân verir.</p>
  `.trim(),

  boards: `
    <h2>Yönetim, Denetim ve Danışma Kurullarımız</h2>
    <p>Vakfımızın şeffaf yönetim yapısı, üç ayrı kurulun denetim ve danışmanlığıyla korunur.</p>
    <h3>Denetim Kurulu</h3>
    <p>Her yıl bağımsız denetim yapar; bağışçılarımıza yıllık şeffaf rapor yayımlar.</p>
    <h3>Üst Danışma Kurulu</h3>
    <p>Eğitim politikaları, sivil toplum ve kurumsal iletişim alanında uzmanlardan oluşur.</p>
  `.trim(),

  about_history: `
    <h2>Tarihçemiz</h2>
    <p>21. Yüzyıl Eğitim ve Kültür Vakfı (YEKÜV), 1992 yılında Av. F. Gülbin Sözen önderliğinde İstanbul'da kurulmuştur. Kuruluşundan bu yana geçen 33 yıl boyunca vakfımız, Türkiye'nin dört bir yanındaki başarılı ancak maddi imkânları kısıtlı öğrencilere burs ve eğitim desteği sağlamıştır.</p>
    <h3>Kilometre Taşları</h3>
    <ul>
      <li><strong>1992:</strong> Vakfın kuruluşu</li>
      <li><strong>2001:</strong> İlk 1.000 bursiyer</li>
      <li><strong>2003:</strong> YEKÜV Nilüfer Gökay Ortaokulu hizmete girdi</li>
      <li><strong>2010:</strong> Ulusal ölçekte büyüme</li>
      <li><strong>2017:</strong> Dijital dönüşüm ve online bağış altyapısı</li>
      <li><strong>2023:</strong> Yeni dönem — gençlik odaklı programlar</li>
    </ul>
  `.trim(),

  about_vision: `
    <h2>Vizyon & Misyon</h2>
    <h3>Vizyonumuz</h3>
    <p>Eğitimde fırsat eşitliğinin sağlandığı, her çocuğun potansiyelini gerçekleştirebildiği bir Türkiye için çalışmak.</p>
    <h3>Misyonumuz</h3>
    <p>Maddi imkânları kısıtlı ancak başarılı öğrencilere burs, mentörlük ve kültürel destek sağlayarak; onların eğitim yolculuklarını kesintisiz sürdürebilmelerini sağlamak. Bunu şeffaf, hesap verebilir ve sürdürülebilir bir yönetim anlayışıyla yapmak.</p>
    <h3>Değerlerimiz</h3>
    <ul>
      <li>Şeffaflık ve hesap verebilirlik</li>
      <li>Eğitimde fırsat eşitliği</li>
      <li>Sivil dayanışma</li>
      <li>Sürdürülebilir etki</li>
    </ul>
  `.trim(),

  kvkk: `
    <h2>Aydınlatma Metni</h2>
    <p>21. Yüzyıl Eğitim ve Kültür Vakfı ("YEKÜV"), 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında kişisel verileriniz hakkında sizleri bilgilendirmekten memnuniyet duyar. Vakfımız, "Veri Sorumlusu" sıfatıyla sizden aldığı verileri aşağıda belirtilen amaçlarla işler.</p>
    <h3>İşleme Amaçları</h3>
    <ul>
      <li>Burs başvurularınızın değerlendirilmesi</li>
      <li>Bağış ve gönüllülük kayıtlarının tutulması</li>
      <li>Vakıf faaliyetleri hakkında bilgilendirme</li>
      <li>Yasal yükümlülüklerin yerine getirilmesi</li>
    </ul>
    <h3>Haklarınız</h3>
    <ul>
      <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
      <li>İşlenmişse bilgi talep etme</li>
      <li>İşleme amacı ve uygun kullanılıp kullanılmadığını öğrenme</li>
      <li>Eksik / yanlış veriyi düzeltme talep etme</li>
      <li>Silinmesini veya yok edilmesini talep etme</li>
    </ul>
  `.trim(),

  tax: `
    <h2>Vergi Muafiyeti</h2>
    <p>21. Yüzyıl Eğitim ve Kültür Vakfı, Bakanlar Kurulu'nun 2017/10099 sayılı kararı ile <strong>vergi muafiyeti tanınan vakıflar</strong> statüsündedir.</p>
    <p>Bu statü sayesinde YEKÜV'e yaptığınız bağışların bir kısmını gelir vergisi matrahından düşme hakkına sahipsiniz.</p>
    <h3>Bağış İndirim Oranı</h3>
    <ul>
      <li>Gerçek kişiler: yıllık gelirinin %5'ine kadar (kalkınmada öncelikli yörelerde %10)</li>
      <li>Kurumlar: yıllık kurum kazancının %5'ine kadar</li>
    </ul>
    <h3>Makbuz Talebi</h3>
    <p>Bağışlarınıza karşılık düzenlenecek makbuzlar için <a href="mailto:info@yekuv.org">info@yekuv.org</a> adresinden bize ulaşabilirsiniz.</p>
  `.trim(),
};

export default STATIC_DEFAULTS;
